import { lazy } from 'react'

export const PaymentVariant3 = lazy(() => import('./PaymentVariant3'))
